<!-- NorthArrow.vue - 方位記号（北矢印）オーバーレイ -->
<template>
  <div
    v-if="isVisible && !isPrint"
    class="north-arrow-container"
    :class="{ 'north-arrow-rotated': bearing !== 0 || pitch !== 0, 'north-arrow-teacher': isTeacher }"
    :style="{ transform: `rotate(${-bearing}deg)` }"
    @click="onClick"
  >
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- 外円 -->
      <circle cx="24" cy="24" r="22" stroke="var(--oh3-color-text-primary)" stroke-width="1.5" fill="var(--oh3-color-overlay-white-90)" />

      <!-- 北矢印（赤い三角） -->
      <path d="M24 6 L30 24 L24 20 L18 24 Z" fill="#d32f2f" stroke="#b71c1c" stroke-width="0.5" />

      <!-- 南矢印（白い三角） -->
      <path d="M24 42 L30 24 L24 28 L18 24 Z" fill="var(--oh3-color-white)" stroke="var(--oh3-color-text-primary)" stroke-width="0.5" />

      <!-- N文字 -->
      <text x="24" y="14" text-anchor="middle" font-size="8" font-weight="bold" fill="#d32f2f">N</text>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'NorthArrow',
  data: () => ({
    bearing: 0,
    pitch: 0,
  }),
  computed: {
    map() {
      return this.$store.state.map01
    },
    isPrint() {
      return this.$store.state.isPrint
    },
    showNorthArrow() {
      return this.$store.state.showNorthArrow
    },
    isTeacher() {
      return this.$store.state.isTeacher
    },
    // オンならずっと表示。オフでもピッチか回転が閾値を超えたら表示
    isVisible() {
      if (this.showNorthArrow) return true
      return Math.abs(this.bearing) > 3 || this.pitch > 5
    }
  },
  methods: {
    onClick() {
      // クリックで北を上に＋ピッチも0に戻す
      if (this.map && (this.bearing !== 0 || this.pitch !== 0)) {
        this.map.easeTo({ bearing: 0, pitch: 0, duration: 300 })
      }
    },
    updateBearing() {
      if (this.map) {
        this.bearing = this.map.getBearing()
      }
    },
    updatePitch() {
      if (this.map) {
        this.pitch = this.map.getPitch()
      }
    },
    setupListeners() {
      if (!this.map) return
      this.map.on('rotate', this.updateBearing)
      this.map.on('pitch', this.updatePitch)
      // 常に初期値を読む（閾値判定で不意な表示は防ぐ）
      this.updateBearing()
      this.updatePitch()
    },
    removeListeners() {
      if (!this.map) return
      this.map.off('rotate', this.updateBearing)
      this.map.off('pitch', this.updatePitch)
    }
  },
  mounted() {
    // localStorageから復元してstoreに設定（リスナー設定より先に行う）
    try {
      const saved = localStorage.getItem('oh3.showNorthArrow') === '1'
      this.$store.state.showNorthArrow = saved
    } catch (_) {}
    if (this.map) {
      this.setupListeners()
    }
  },
  watch: {
    map(newMap) {
      if (newMap) {
        this.setupListeners()
      }
    }
  },
  beforeUnmount() {
    this.removeListeners()
  }
}
</script>

<style scoped>
.north-arrow-container {
  position: fixed;
  top: 70px;
  left: 10px;
  z-index: 100;
  cursor: pointer;
  transition: transform 0.1s ease-out;
  filter: drop-shadow(0 2px 4px var(--oh3-color-overlay-30));
}

.north-arrow-container:hover {
  filter: drop-shadow(0 3px 6px var(--oh3-color-overlay-50));
}

/* 教員ログイン時も通常と同じ位置 */
.north-arrow-teacher {
  top: 70px;
}

/* 回転時はクリック可能であることを示す */
.north-arrow-rotated:hover svg circle {
  stroke: var(--oh3-color-link);
}

@media (max-width: 500px) {
  .north-arrow-container {
    top: 70px;
    left: 8px;
  }
  .north-arrow-container svg {
    width: 40px;
    height: 40px;
  }
}
</style>
